<template>
  <div style="margin-bottom: 50px">
    <br />
    <el-row type="flex" justify="center" :gutter="26">
      <el-col :span="24">
        <center>
          <el-select
            @change="reloadData"
            v-model="faena_selected"
            size="medium"
            placeholder="Seleccione Faena"
            style="margin-right: 10px"
          >
            <el-option
              v-for="item in listadoFaenas"
              :key="item.faena_id"
              :label="item.nombre"
              :value="item.faena_id"
            ></el-option>
          </el-select>
          <el-button
            size="medium"
            type="primary"
            @click="printdiv('print')"
            icon="el-icon-printer"
            >Imprimir</el-button
          >
        </center>
      </el-col>
    </el-row>
    <br />
    <br />
    <center v-if="loading">
      <br />
      <br />
      <Circle9 style="margin-bottom: 8px"></Circle9>
      <small>Cargando Datos ...</small>
      <br />
      <br />
    </center>
    <el-card
      :class="{ resize_content: loading, 'none-display': loading }"
      id="print"
      class="box-card printme"
    >
      <el-row :gutter="26">
        <el-col :span="24">
          <center>
            <h2>REPORTE SEMANAL</h2>
          </center>
          <br />
        </el-col>
        <el-col :span="24">
          <span>
            <b>FECHA:</b>
            {{ getDate() }}
          </span>
          <br />
          <span>
            <b>FAENA:</b>
            {{ faenaName(faena_selected) }}
          </span>
          <br />
        </el-col>
        <el-col :span="24">
          <br class="salto_linea" />
          <br />
          <h3>CONTRATISTAS</h3>
          <br />
        </el-col>
        <el-col :sm="24" style="overflow: auto; overflow-y: hidden">
          <!-- TABLE MIN 601PX WIDTH -->
          <table border="1" cellspacing="0" class="full-table">
            <tr>
              <td class="padding_cell background_gray color_white">
                <b>GERENCIA</b>
              </td>
              <td class="padding_cell background_gray color_white text-center">
                <b>APROBADOS</b>
              </td>
              <td class="padding_cell background_gray color_white text-center">
                <b>BORRADOR</b>
              </td>
              <td class="padding_cell background_gray color_white text-center">
                <b>REVISIÓN</b>
              </td>
              <td class="padding_cell background_gray color_white text-center">
                <b>NO INICIADO</b>
              </td>
            </tr>
            <tr v-for="(item, index) in structure" :key="index">
              <td class="padding_cell">{{ item.nombre }}</td>
              <td
                style="background-color: #abebc6"
                class="padding_cell text-center aprobado"
              >
                {{
                  redondear(
                    item.contratistas.aprobados,
                    item.contratistas.aprobados +
                      item.contratistas.borrador +
                      item.contratistas.revision +
                      item.contratistas.no_iniciado
                  ) === 0
                    ? "N/A"
                    : redondear(
                        item.contratistas.aprobados,
                        item.contratistas.aprobados +
                          item.contratistas.borrador +
                          item.contratistas.revision +
                          item.contratistas.no_iniciado
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    item.contratistas.borrador,
                    item.contratistas.aprobados +
                      item.contratistas.borrador +
                      item.contratistas.revision +
                      item.contratistas.no_iniciado
                  ) === 0
                    ? "N/A"
                    : redondear(
                        item.contratistas.borrador,
                        item.contratistas.aprobados +
                          item.contratistas.borrador +
                          item.contratistas.revision +
                          item.contratistas.no_iniciado
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    item.contratistas.revision,
                    item.contratistas.aprobados +
                      item.contratistas.borrador +
                      item.contratistas.revision +
                      item.contratistas.no_iniciado
                  ) === 0
                    ? "N/A"
                    : redondear(
                        item.contratistas.revision,
                        item.contratistas.aprobados +
                          item.contratistas.borrador +
                          item.contratistas.revision +
                          item.contratistas.no_iniciado
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    item.contratistas.no_iniciado,
                    item.contratistas.aprobados +
                      item.contratistas.borrador +
                      item.contratistas.revision +
                      item.contratistas.no_iniciado
                  ) === 0
                    ? "N/A"
                    : redondear(
                        item.contratistas.no_iniciado,
                        item.contratistas.aprobados +
                          item.contratistas.borrador +
                          item.contratistas.revision +
                          item.contratistas.no_iniciado
                      ) + "%"
                }}
              </td>
            </tr>
          </table>

          <!-- TABLE MAX 600PX -->
          <table
            class="min-table"
            border="1"
            cellspacing="0"
            v-for="(item, index) in structure"
            :key="index"
            width="100%"
            style="margin-bottom: 10px"
          >
            <tr>
              <td colspan="4" class="padding_cell background_gray color_white">
                <center>
                  <b>{{ item.nombre }}</b>
                </center>
              </td>
            </tr>
            <tr>
              <td
                class="padding_cell text-center"
                style="background-color: #abebc6"
              >
                <center>
                  APROBADOS
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        item.contratistas.aprobados,
                        item.contratistas.aprobados +
                          item.contratistas.borrador +
                          item.contratistas.revision +
                          item.contratistas.no_iniciado
                      ) === 0
                        ? "N/A"
                        : redondear(
                            item.contratistas.aprobados,
                            item.contratistas.aprobados +
                              item.contratistas.borrador +
                              item.contratistas.revision +
                              item.contratistas.no_iniciado
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  BORRADOR
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        item.contratistas.borrador,
                        item.contratistas.aprobados +
                          item.contratistas.borrador +
                          item.contratistas.revision +
                          item.contratistas.no_iniciado
                      ) === 0
                        ? "N/A"
                        : redondear(
                            item.contratistas.borrador,
                            item.contratistas.aprobados +
                              item.contratistas.borrador +
                              item.contratistas.revision +
                              item.contratistas.no_iniciado
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  REVISIÓN
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        item.contratistas.revision,
                        item.contratistas.aprobados +
                          item.contratistas.borrador +
                          item.contratistas.revision +
                          item.contratistas.no_iniciado
                      ) === 0
                        ? "N/A"
                        : redondear(
                            item.contratistas.revision,
                            item.contratistas.aprobados +
                              item.contratistas.borrador +
                              item.contratistas.revision +
                              item.contratistas.no_iniciado
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  NO INICIADO
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        item.contratistas.no_iniciado,
                        item.contratistas.aprobados +
                          item.contratistas.borrador +
                          item.contratistas.revision +
                          item.contratistas.no_iniciado
                      ) === 0
                        ? "N/A"
                        : redondear(
                            item.contratistas.no_iniciado,
                            item.contratistas.aprobados +
                              item.contratistas.borrador +
                              item.contratistas.revision +
                              item.contratistas.no_iniciado
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
            </tr>
          </table>
        </el-col>
      </el-row>
      <el-row align="middle" type="flex" class="page-break">
        <el-col :md="12" style="overflow: auto; overflow-y: hidden">
          <br />
          <br />
          <vue-c3 :handler="handler"></vue-c3>
        </el-col>
        <el-col :sm="12" :key="render">
          <div
            v-if="JSON.stringify(statusContratista.data) !== '{}'"
            class="info"
            style="
              margin: 0 auto;
              border: 2px solid black;
              width: 150px;
              padding: 10px;
              background-color: #e6e6e6;
            "
          >
            <table>
              <tr>
                <td colspan="2" style="border-bottom: 2px solid black">
                  <b>{{ statusContratista.title }}</b>
                  <br /><br />
                </td>
              </tr>
              <tr>
                <td><br /></td>
              </tr>
              <tr v-for="(item, index) in statusContratista.data" :key="index">
                <td style="font-size: 16px">{{ index }} :</td>
                <td style="font-size: 16px">
                  <b>{{ item }}</b>
                </td>
              </tr>
            </table>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <br />
          <br />
          <hr class="hr" />
        </el-col>
        <el-col :span="24">
          <div class="page-break"></div>
          <br />
          <h3>PROPIOS</h3>
          <br />
        </el-col>
        <el-col :md="24">
          <table border="1" cellspacing="0" class="full-table">
            <tr>
              <td class="padding_cell background_gray color_white">
                <b>GERENCIA</b>
              </td>
              <td class="padding_cell background_gray color_white text-center">
                <b>APROBADOS</b>
              </td>
              <td class="padding_cell background_gray color_white text-center">
                <b>BORRADOR</b>
              </td>
              <td class="padding_cell background_gray color_white text-center">
                <b>REVISIÓN</b>
              </td>
              <td class="padding_cell background_gray color_white text-center">
                <b>NO INICIADO</b>
              </td>
            </tr>
            <tr v-for="(item, index) in structure" :key="index">
              <td class="padding_cell">{{ item.nombre }}</td>
              <td
                style="background-color: #abebc6"
                class="padding_cell text-center aprobado"
              >
                {{
                  redondear(
                    item.propios.aprobados,
                    item.propios.aprobados +
                      item.propios.borrador +
                      item.propios.revision +
                      item.propios.no_iniciado
                  ) === 0
                    ? "N/A"
                    : redondear(
                        item.propios.aprobados,
                        item.propios.aprobados +
                          item.propios.borrador +
                          item.propios.revision +
                          item.propios.no_iniciado
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    item.propios.borrador,
                    item.propios.aprobados +
                      item.propios.borrador +
                      item.propios.revision +
                      item.propios.no_iniciado
                  ) === 0
                    ? "N/A"
                    : redondear(
                        item.propios.borrador,
                        item.propios.aprobados +
                          item.propios.borrador +
                          item.propios.revision +
                          item.propios.no_iniciado
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    item.propios.revision,
                    item.propios.aprobados +
                      item.propios.borrador +
                      item.propios.revision +
                      item.propios.no_iniciado
                  ) === 0
                    ? "N/A"
                    : redondear(
                        item.propios.revision,
                        item.propios.aprobados +
                          item.propios.borrador +
                          item.propios.revision +
                          item.propios.no_iniciado
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    item.propios.no_iniciado,
                    item.propios.aprobados +
                      item.propios.borrador +
                      item.propios.revision +
                      item.propios.no_iniciado
                  ) === 0
                    ? "N/A"
                    : redondear(
                        item.propios.no_iniciado,
                        item.propios.aprobados +
                          item.propios.borrador +
                          item.propios.revision +
                          item.propios.no_iniciado
                      ) + "%"
                }}
              </td>
            </tr>
          </table>

          <!-- TABLE MAX 600PX -->
          <table
            class="min-table"
            border="1"
            cellspacing="0"
            v-for="(item, index) in structure"
            :key="index"
            width="100%"
            style="margin-bottom: 10px"
          >
            <tr>
              <td colspan="4" class="padding_cell background_gray color_white">
                <center>
                  <b>{{ item.nombre }}</b>
                </center>
              </td>
            </tr>
            <tr>
              <td
                class="padding_cell text-center"
                style="background-color: #abebc6"
              >
                <center>
                  APROBADOS
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        item.propios.aprobados,
                        item.propios.aprobados +
                          item.propios.borrador +
                          item.propios.revision +
                          item.propios.no_iniciado
                      ) === 0
                        ? "N/A"
                        : redondear(
                            item.propios.aprobados,
                            item.propios.aprobados +
                              item.propios.borrador +
                              item.propios.revision +
                              item.propios.no_iniciado
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  BORRADOR
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        item.propios.borrador,
                        item.propios.aprobados +
                          item.propios.borrador +
                          item.propios.revision +
                          item.propios.no_iniciado
                      ) === 0
                        ? "N/A"
                        : redondear(
                            item.propios.borrador,
                            item.propios.aprobados +
                              item.propios.borrador +
                              item.propios.revision +
                              item.propios.no_iniciado
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  REVISIÓN
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        item.propios.revision,
                        item.propios.aprobados +
                          item.propios.borrador +
                          item.propios.revision +
                          item.propios.no_iniciado
                      ) === 0
                        ? "N/A"
                        : redondear(
                            item.propios.revision,
                            item.propios.aprobados +
                              item.propios.borrador +
                              item.propios.revision +
                              item.propios.no_iniciado
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  NO INICIADO
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        item.propios.no_iniciado,
                        item.propios.aprobados +
                          item.propios.borrador +
                          item.propios.revision +
                          item.propios.no_iniciado
                      ) === 0
                        ? "N/A"
                        : redondear(
                            item.propios.no_iniciado,
                            item.propios.aprobados +
                              item.propios.borrador +
                              item.propios.revision +
                              item.propios.no_iniciado
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
            </tr>
          </table>
        </el-col>
      </el-row>
      <el-row align="middle" type="flex" class="page-break">
        <el-col :sm="12" style="overflow: auto; overflow-y: hidden">
          <br />
          <br />
          <vue-c3 :handler="propiosChart"></vue-c3>
        </el-col>
        <el-col :sm="12" :key="render">
          <div
            v-if="JSON.stringify(statusPropio.data) !== '{}'"
            class="info"
            style="
              margin: 0 auto;
              border: 2px solid black;
              width: 150px;
              padding: 10px;
              background-color: #e6e6e6;
            "
          >
            <table>
              <tr>
                <td colspan="2" style="border-bottom: 2px solid black">
                  <b>{{ statusPropio.title }}</b>
                  <br /><br />
                </td>
              </tr>
              <tr>
                <td><br /></td>
              </tr>
              <tr v-for="(item, index) in statusPropio.data" :key="index">
                <td style="font-size: 16px">{{ index }} :</td>
                <td style="font-size: 16px">
                  <b>{{ item }}</b>
                </td>
              </tr>
            </table>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <br />
          <br />
          <br class="salto_linea" />
          <hr class="hr" />
        </el-col>
        <el-col :span="24">
          <div class="page-break"></div>
          <br />
          <h3>
            STATUS INVENTARIOS {{ faenaName(faena_selected) }} + CONTRATISTAS
          </h3>
        </el-col>
        <el-col :lg="24" :xl="24">
          <br />
          <table border="1" cellspacing="0" class="full-table">
            <tr>
              <td class="padding_cell background_gray color_white"></td>
              <td class="padding_cell background_gray color_white">
                <b>APROBADOS</b>
              </td>
              <td class="padding_cell background_gray color_white">
                <b>BORRADOR</b>
              </td>
              <td class="padding_cell background_gray color_white">
                <b>REVISIÓN</b>
              </td>
              <td class="padding_cell background_gray color_white">
                <b>NO INICIADO</b>
              </td>
            </tr>
            <tr>
              <td class="padding_cell text-center">CONTRATISTAS</td>
              <td
                style="background-color: #abebc6"
                class="padding_cell text-center aprobado"
              >
                {{
                  redondear(
                    table_propio_contratista.contratistas.aprobados,
                    table_propio_contratista.contratistas.total
                  ) === 0
                    ? "N/A"
                    : redondear(
                        table_propio_contratista.contratistas.aprobados,
                        table_propio_contratista.contratistas.total
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    table_propio_contratista.contratistas.borrador,
                    table_propio_contratista.contratistas.total
                  ) === 0
                    ? "N/A"
                    : redondear(
                        table_propio_contratista.contratistas.borrador,
                        table_propio_contratista.contratistas.total
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    table_propio_contratista.contratistas.revision,
                    table_propio_contratista.contratistas.total
                  ) === 0
                    ? "N/A"
                    : redondear(
                        table_propio_contratista.contratistas.revision,
                        table_propio_contratista.contratistas.total
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    table_propio_contratista.contratistas.no_iniciado,
                    table_propio_contratista.contratistas.total
                  ) === 0
                    ? "N/A"
                    : redondear(
                        table_propio_contratista.contratistas.no_iniciado,
                        table_propio_contratista.contratistas.total
                      ) + "%"
                }}
              </td>
            </tr>
            <tr>
              <td class="padding_cell text-center">
                {{ faenaName(faena_selected) }}
              </td>
              <td
                style="background-color: #abebc6"
                class="padding_cell text-center aprobado"
              >
                {{
                  redondear(
                    table_propio_contratista.propios.aprobados,
                    table_propio_contratista.propios.total
                  ) === 0
                    ? "N/A"
                    : redondear(
                        table_propio_contratista.propios.aprobados,
                        table_propio_contratista.propios.total
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    table_propio_contratista.propios.borrador,
                    table_propio_contratista.propios.total
                  ) === 0
                    ? "N/A"
                    : redondear(
                        table_propio_contratista.propios.borrador,
                        table_propio_contratista.propios.total
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    table_propio_contratista.propios.revision,
                    table_propio_contratista.propios.total
                  ) === 0
                    ? "N/A"
                    : redondear(
                        table_propio_contratista.propios.revision,
                        table_propio_contratista.propios.total
                      ) + "%"
                }}
              </td>
              <td class="padding_cell text-center">
                {{
                  redondear(
                    table_propio_contratista.propios.no_iniciado,
                    table_propio_contratista.propios.total
                  ) === 0
                    ? "N/A"
                    : redondear(
                        table_propio_contratista.propios.no_iniciado,
                        table_propio_contratista.propios.total
                      ) + "%"
                }}
              </td>
            </tr>
          </table>

          <!-- TABLE MAX 600PX -->
          <table
            class="min-table"
            border="1"
            cellspacing="0"
            width="100%"
            style="margin-bottom: 10px"
          >
            <tr>
              <td colspan="4" class="padding_cell background_gray color_white">
                <center>
                  <b>CONTRATISTAS</b>
                </center>
              </td>
            </tr>
            <tr>
              <td
                class="padding_cell text-center"
                style="background-color: #abebc6"
              >
                <center>
                  APROBADOS
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        table_propio_contratista.contratistas.aprobados,
                        table_propio_contratista.contratistas.total
                      ) === 0
                        ? "N/A"
                        : redondear(
                            table_propio_contratista.contratistas.aprobados,
                            table_propio_contratista.contratistas.total
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  BORRADOR
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        table_propio_contratista.contratistas.borrador,
                        table_propio_contratista.contratistas.total
                      ) === 0
                        ? "N/A"
                        : redondear(
                            table_propio_contratista.contratistas.borrador,
                            table_propio_contratista.contratistas.total
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  REVISIÓN
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        table_propio_contratista.contratistas.revision,
                        table_propio_contratista.contratistas.total
                      ) === 0
                        ? "N/A"
                        : redondear(
                            table_propio_contratista.contratistas.revision,
                            table_propio_contratista.contratistas.total
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  NO INICIADO
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        table_propio_contratista.contratistas.no_iniciado,
                        table_propio_contratista.contratistas.total
                      ) === 0
                        ? "N/A"
                        : redondear(
                            table_propio_contratista.contratistas.no_iniciado,
                            table_propio_contratista.contratistas.total
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
            </tr>
          </table>

          <table
            class="min-table"
            border="1"
            cellspacing="0"
            width="100%"
            style="margin-bottom: 10px"
          >
            <tr>
              <td colspan="4" class="padding_cell background_gray color_white">
                <center>
                  <b>{{ faenaName(faena_selected) }}</b>
                </center>
              </td>
            </tr>
            <tr>
              <td
                class="padding_cell text-center"
                style="background-color: #abebc6"
              >
                <center>
                  APROBADOS
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        table_propio_contratista.propios.aprobados,
                        table_propio_contratista.propios.total
                      ) === 0
                        ? "N/A"
                        : redondear(
                            table_propio_contratista.propios.aprobados,
                            table_propio_contratista.propios.total
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  BORRADOR
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        table_propio_contratista.contratistas.borrador,
                        table_propio_contratista.contratistas.total
                      ) === 0
                        ? "N/A"
                        : redondear(
                            table_propio_contratista.contratistas.borrador,
                            table_propio_contratista.contratistas.total
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  REVISIÓN
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        table_propio_contratista.contratistas.revision,
                        table_propio_contratista.contratistas.total
                      ) === 0
                        ? "N/A"
                        : redondear(
                            table_propio_contratista.contratistas.revision,
                            table_propio_contratista.contratistas.total
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
              <td class="padding_cell text-center">
                <center>
                  NO INICIADO
                  <br />
                  <div style="margin-top: 4px; font-size: 16px">
                    {{
                      redondear(
                        table_propio_contratista.contratistas.no_iniciado,
                        table_propio_contratista.contratistas.total
                      ) === 0
                        ? "N/A"
                        : redondear(
                            table_propio_contratista.contratistas.no_iniciado,
                            table_propio_contratista.contratistas.total
                          ) + "%"
                    }}
                  </div>
                </center>
              </td>
            </tr>
          </table>
        </el-col>
      </el-row>
      <br />
      <br />
      <br />
      <el-row align="middle" type="flex">
        <el-col :sm="12" style="overflow: auto; overflow-y: hidden">
          <br />
          <br />
          <vue-c3 :handler="contratistaPropio"></vue-c3>
          <br />
          <br />
        </el-col>
        <el-col :sm="12" :key="render">
          <div
            v-if="JSON.stringify(statusContratistaPropio.data) !== '{}'"
            class="info"
            style="
              margin: 0 auto;
              border: 2px solid black;
              width: 150px;
              padding: 10px;
              background-color: #e6e6e6;
            "
          >
            <table>
              <tr>
                <td colspan="2" style="border-bottom: 2px solid black">
                  <b>{{ statusContratistaPropio.title }}</b>
                  <br /><br />
                </td>
              </tr>
              <tr>
                <td><br /></td>
              </tr>
              <tr
                v-for="(item, index) in statusContratistaPropio.data"
                :key="index"
              >
                <td style="font-size: 16px">{{ index }} :</td>
                <td style="font-size: 16px">
                  <b>{{ item }}</b>
                </td>
              </tr>
            </table>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import axios from "axios";
import VueC3 from "vue-c3";
import { Circle9 } from "vue-loading-spinner";

export default {
  name: "reportWeek",
  data() {
    return {
      render: 0,
      statusContratista: {
        title: "",
        data: {},
      },
      statusPropio: {
        title: "",
        data: {},
      },
      statusContratistaPropio: {
        title: "",
        data: {},
      },
      handler: new Vue(),
      propiosChart: new Vue(),
      contratistaPropio: new Vue(),
      arbol: [],
      faena_selected: "5a6f78337b772dcfe68241d5",
      listadoFaenas: [
        {
          nombre: "MEL",
          faena_id: "5a6f78337b772dcfe68241d5",
        },
        {
          nombre: "SPENCE",
          faena_id: "5a6f78417b772dcfe68241e5",
        },
        {
          nombre: "CERRO COLORADO",
          faena_id: "5a6f784e7b772dcfe68241f4",
        },
        {
          nombre: "BHP",
          faena_id: "5b48f15d6f0ed90fc02826e3",
        },
      ],
      structure: [],
      loading: false,
      table_propio_contratista: {
        propios: {
          aprobados: 0,
          borrador: 0,
          revision: 0,
          no_iniciado: 0,
          total: 0,
        },
        contratistas: {
          aprobados: 0,
          borrador: 0,
          revision: 0,
          no_iniciado: 0,
          total: 0,
        },
      },
    };
  },
  mounted() {
    this.chargeCharts(this.faena_selected);
  },
  components: {
    VueC3,
    Circle9,
  },
  methods: {
    reloadData(fanea_id) {
      this.chargeCharts(fanea_id);
    },
    printdiv(elementId) {
      const divContents = document.getElementById("print").innerHTML;
      const a = window.open("", "", "height=780, width=1300");
      a.document.write("<html>");
      a.document.write(`
            <style>
              @media print {
                .page-break {
                  display:block;
                  page-break-before:always;
                }

                .info {
                  margin-top: 100px !important;
                }
              }

              .min-table {
                display: none;
              }

              .aprobado {
                background-color:#ABEBC6;
                -webkit-print-color-adjust: exact;
              }

              body {
                font-size: 13px;
                font-family: Arial, Helvetica, sans-serif;
              }

              table {
                font-size: 13px;
                font-family: Arial, Helvetica, sans-serif;
              }

              td {
                padding: 5px;
              }

              .salto_linea {
                display: inline-block;
              }
              .hr {
                display: none;
              }
            </style>
            `);
      a.document.write('<body id="print">');
      a.document.write(divContents);
      a.document.write("</body></html>");
      a.document.close();
      a.print();
    },
    redondear(valor, total) {
      if (valor === 0) {
        return 0;
      }
      const redondeo = (valor * 100) / total;
      return Math.round(redondeo);
    },
    generateGraphBarPropiosContratistas(colums, group) {
      var self = this;
      const faena = this.faenaName(this.faena_selected);
      const options = {
        data: {
          onclick: function (d, element) {
            let repeat = [];
            let labels = ["CONTRATISTAS", "MEL"];
            self.statusContratistaPropio["title"] = labels[d.index];
            colums.forEach((c, i) => {
              if (!repeat.includes(i)) {
                self.statusContratistaPropio.data[c[0]] = c[d.index + 1];
                repeat.push(i);
              }
            });
            self.render = self.render + 1;
          },
          order: null,
          columns: colums,
          type: "bar",
          groups: [group],
          colors: {
            Aprobados: "#58D68D",
            Borrador: "#D7DBDD",
            Revision: "#BDC3C7",
            "No iniciado": "#909497",
          },
        },
        tooltip: {
          show: false,
        },
        size: {
          height: 200,
          width: 700,
        },
        legend: {
          show: true,
          position: "right",
        },
        axis: {
          rotated: true,
          x: {
            type: "category",
            categories: ["CONTRATISTAS", faena],
            tick: {
              rotate: 0,
              multiline: false,
            },
          },
          y: { show: false },
        },
      };
      this.contratistaPropio.$emit("init", options);
    },
    generateGraphBarContratistas(colums, group, labels) {
      var self = this;
      const options = {
        data: {
          onclick: function (d, element) {
            let repeat = [];
            self.statusContratista["title"] = labels[d.index];
            colums.forEach((c, i) => {
              if (!repeat.includes(i)) {
                self.statusContratista.data[c[0]] = c[d.index + 1];
                repeat.push(i);
              }
            });
            self.render = self.render + 1;
          },
          order: null,
          columns: colums,
          type: "bar",
          groups: [group],
          colors: {
            Aprobados: "#58D68D",
            Borrador: "#D7DBDD",
            Revision: "#BDC3C7",
            "No iniciado": "#909497",
          },
        },
        tooltip: {
          show: false,
        },
        size: {
          height: 500,
          width: 700,
        },
        legend: {
          show: true,
          position: "right",
        },
        axis: {
          rotated: true,
          x: {
            type: "category",
            categories: labels,
            tick: {
              rotate: 0,
              multiline: false,
            },
          },
          y: { show: false },
        },
      };
      this.handler.$emit("init", options);
    },
    generateGraphBarPropios(colums, group, labels) {
      var self = this;
      const options = {
        data: {
          onclick: function (d, element) {
            let repeat = [];
            self.statusPropio["title"] = labels[d.index];
            colums.forEach((c, i) => {
              if (!repeat.includes(i)) {
                self.statusPropio.data[c[0]] = c[d.index + 1];
                repeat.push(i);
              }
            });
            self.render = self.render + 1;
          },
          order: null,
          columns: colums,
          type: "bar",
          groups: [group],
          colors: {
            Aprobados: "#58D68D",
            Borrador: "#D7DBDD",
            Revision: "#BDC3C7",
            "No iniciado": "#909497",
          },
        },
        tooltip: {
          show: false,
        },
        size: {
          height: 500,
          width: 700,
        },
        legend: {
          show: true,
          position: "right",
        },
        axis: {
          rotated: true,
          x: {
            type: "category",
            categories: labels,
            tick: {
              rotate: 0,
              multiline: false,
            },
          },
          y: { show: false },
        },
      };
      this.propiosChart.$emit("init", options);
    },
    totalBorrador(type) {
      let total = 0;
      if (type === "contratista") {
        this.structure.forEach((item) => {
          total += item.contratistas.borrador;
        });
      } else {
        this.structure.forEach((item) => {
          total += item.propios.borrador;
        });
      }
      return total;
    },
    totalAprobados(type) {
      let total = 0;
      if (type === "contratista") {
        this.structure.forEach((item) => {
          total += item.contratistas.aprobados;
        });
      } else {
        this.structure.forEach((item) => {
          total += item.propios.aprobados;
        });
      }
      return total;
    },
    totalRevision(type) {
      let total = 0;
      if (type === "contratista") {
        this.structure.forEach((item) => {
          total += item.contratistas.revision;
        });
      } else {
        this.structure.forEach((item) => {
          total += item.propios.revision;
        });
      }
      return total;
    },
    totalNoIniciado(type) {
      let total = 0;
      if (type === "contratista") {
        this.structure.forEach((item) => {
          total += item.contratistas.no_iniciado;
        });
      } else {
        this.structure.forEach((item) => {
          total += item.propios.no_iniciado;
        });
      }
      return total;
    },
    totalGeneral(type) {
      let total = 0;
      total =
        this.totalBorrador(type) +
        this.totalAprobados(type) +
        this.totalRevision(type) +
        this.totalNoIniciado(type);
      return total;
    },
    getDate(date) {
      return moment().format("DD/MM/YYYY");
    },
    faenaName(id) {
      const diccionario = {
        "5a6f78337b772dcfe68241d5": "MEL",
        "5a6f78417b772dcfe68241e5": "SPENCE",
        "5a6f784e7b772dcfe68241f4": "CERRO COLORADO",
        "5b48f15d6f0ed90fc02826e3": "BHP",
      };
      return diccionario[id];
    },
    async chargeCharts(faenaId) {
      this.loading = true;
      this.structure = [];
      const dataContracts = await axios.get(
        `/data-science/contratos/getContractsInventoryStatus/${faenaId}`
      );
      const contracts = dataContracts.data;

      const contratosContratistas = contracts.filter(
        (c) => c.tipo_contrato === "Contratista"
      );

      const contratosPropios = contracts.filter(
        (c) => c.tipo_contrato === "Propio"
      );

      let data_gerencia = {
        nombre: "",
        areas_hijas: [],
      };
      const result = await axios
        .get("/data-science/arbol-bhp/" + faenaId, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .catch((error) => {
          if (error) {
            console.log(error);
          }
        });
      const arbol = result.data.filter((x) => x._id === faenaId);
      arbol.forEach((asset) => {
        if (asset.operaciones) {
          asset.operaciones.forEach((operacion) => {
            data_gerencia = {
              nombre: "",
              areas_hijas: [],
            };
            data_gerencia.nombre = operacion.nombre;
            data_gerencia.areas_hijas.push(operacion._id);
            if (operacion.gerencias) {
              operacion.gerencias.forEach((gerencia) => {
                data_gerencia.areas_hijas.push(gerencia._id);
                if (gerencia.superintendencias) {
                  gerencia.superintendencias.forEach((superintendencia) => {
                    data_gerencia.areas_hijas.push(superintendencia._id);
                    if (superintendencia.areas) {
                      superintendencia.areas.forEach((area) => {
                        data_gerencia.areas_hijas.push(area._id);
                        if (area.subareas) {
                          area.subareas.forEach((subarea) => {
                            data_gerencia.areas_hijas.push(subarea._id);
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
            this.structure.push(data_gerencia);
            data_gerencia = {
              nombre: "",
              areas_hijas: [],
            };
          });
        }
      });

      this.structure.forEach((item) => {
        const contratistas = contratosContratistas.filter((el) =>
          item.areas_hijas.includes(el.area_id)
        );
        const propios = contratosPropios.filter((el) =>
          item.areas_hijas.includes(el.area_id)
        );
        item.contratistas = {};
        item.propios = {};
        // CONTRATISTAS
        item.contratistas.aprobados = contratistas.filter(function (el) {
          if (el.inventario && el.inventario.wasApproved) {
            return (
              (el.inventario &&
                (el.inventario.status === 2 || el.inventario.status === "2")) ||
              (el.inventario && el.inventario.wasApproved === true)
            );
          } else {
            return (
              el.inventario &&
              (el.inventario.status === 2 || el.inventario.status === "2")
            );
          }
        }).length;

        item.contratistas.borrador = contratistas.filter(function (el) {
          if (el.inventario && el.inventario.wasApproved) {
            return (
              el.inventario &&
              (el.inventario.status === 0 || el.inventario.status === "0") &&
              el.inventario &&
              el.inventario.wasApproved === false
            );
          } else {
            return (
              el.inventario &&
              (el.inventario.status === 0 || el.inventario.status === "0")
            );
          }
        }).length;
        item.contratistas.revision = contratistas.filter(function (el) {
          if (el.inventario && el.inventario.wasApproved) {
            return (
              el.inventario &&
              (el.inventario.status === 1 ||
                el.inventario.status === "1" ||
                el.inventario.status === "4" ||
                el.inventario.status === 4) &&
              el.inventario &&
              el.inventario.wasApproved === false
            );
          } else {
            return (
              el.inventario &&
              (el.inventario.status === 1 ||
                el.inventario.status === "1" ||
                el.inventario.status === "4" ||
                el.inventario.status === 4)
            );
          }
        }).length;
        item.contratistas.no_iniciado = contratistas.filter(
          (el) => !el.inventario
        ).length;

        // PROPIOS
        item.propios.aprobados = propios.filter(function (el) {
          if (el.inventario && el.inventario.wasApproved) {
            return (
              (el.inventario &&
                (el.inventario.status === 2 || el.inventario.status === "2")) ||
              (el.inventario && el.inventario.wasApproved === true)
            );
          } else {
            return (
              el.inventario &&
              (el.inventario.status === 2 || el.inventario.status === "2")
            );
          }
        }).length;
        item.propios.borrador = propios.filter(function (el) {
          if (el.inventario && el.inventario.wasApproved) {
            return (
              el.inventario &&
              (el.inventario.status === 0 || el.inventario.status === "0") &&
              el.inventario &&
              el.inventario.wasApproved === false
            );
          } else {
            return (
              el.inventario &&
              (el.inventario.status === 0 || el.inventario.status === "0")
            );
          }
        }).length;
        item.propios.revision = propios.filter(function (el) {
          if (el.inventario && el.inventario.wasApproved) {
            return (
              el.inventario &&
              (el.inventario.status === 1 ||
                el.inventario.status === "1" ||
                el.inventario.status === "4" ||
                el.inventario.status === 4) &&
              el.inventario &&
              el.inventario.wasApproved === false
            );
          } else {
            return (
              el.inventario &&
              (el.inventario.status === 1 ||
                el.inventario.status === "1" ||
                el.inventario.status === "4" ||
                el.inventario.status === 4)
            );
          }
        }).length;
        item.propios.no_iniciado = propios.filter(
          (el) => !el.inventario
        ).length;
      });
      // CONTRATISTAS
      // NOMBRES COLUMNAS
      const name_colums = this.structure.map((item) => item.nombre);
      // APROBADOS
      const total_aprobados = this.structure.map(
        (item) => item.contratistas.aprobados
      );
      let status_aprobados = ["Aprobados"];
      status_aprobados = status_aprobados.concat(total_aprobados);
      // BORRADOR
      const total_borrador = this.structure.map(
        (item) => item.contratistas.borrador
      );
      let status_borrador = ["Borrador"];
      status_borrador = status_borrador.concat(total_borrador);
      // REVISION
      const total_revision = this.structure.map(
        (item) => item.contratistas.revision
      );
      let status_revision = ["Revision"];
      status_revision = status_revision.concat(total_revision);
      // NO INICIADOS
      const total_no_iniciados = this.structure.map(
        (item) => item.contratistas.no_iniciado
      );
      let status_no_iniciado = ["No iniciado"];
      status_no_iniciado = status_no_iniciado.concat(total_no_iniciados);

      this.generateGraphBarContratistas(
        [
          status_aprobados,
          status_borrador,
          status_revision,
          status_no_iniciado,
        ],
        ["Aprobados", "Borrador", "Revision", "No iniciado"],
        name_colums
      );
      // PROPIOS
      // NOMBRES COLUMNAS
      const name_colums_propio = this.structure.map((item) => item.nombre);
      // APROBADOS
      const total_aprobados_propio = this.structure.map(
        (item) => item.propios.aprobados
      );
      let status_aprobados_propio = ["Aprobados"];
      status_aprobados_propio = status_aprobados_propio.concat(
        total_aprobados_propio
      );
      // BORRADOR
      const total_borrador_propio = this.structure.map(
        (item) => item.propios.borrador
      );
      let status_borrador_propio = ["Borrador"];
      status_borrador_propio = status_borrador_propio.concat(
        total_borrador_propio
      );
      // REVISION
      const total_revision_propio = this.structure.map(
        (item) => item.propios.revision
      );
      let status_revision_propio = ["Revision"];
      status_revision_propio = status_revision_propio.concat(
        total_revision_propio
      );
      // NO INICIADOS
      const total_no_iniciados_propio = this.structure.map(
        (item) => item.propios.no_iniciado
      );
      let status_no_iniciado_propio = ["No iniciado"];
      status_no_iniciado_propio = status_no_iniciado_propio.concat(
        total_no_iniciados_propio
      );

      this.generateGraphBarPropios(
        [
          status_aprobados_propio,
          status_borrador_propio,
          status_revision_propio,
          status_no_iniciado_propio,
        ],
        ["Aprobados", "Borrador", "Revision", "No iniciado"],
        name_colums_propio
      );

      // TOTAL GENERAL
      const total_aprobados_c = contratosContratistas.filter(
        (el) =>
          el.inventario &&
          (el.inventario.status === 2 || el.inventario.status === "2")
      ).length;
      const total_borrador_c = contratosContratistas.filter(
        (el) =>
          el.inventario &&
          (el.inventario.status === 0 || el.inventario.status === "0")
      ).length;
      const total_revision_c = contratosContratistas.filter(
        (el) =>
          el.inventario &&
          (el.inventario.status === 1 || el.inventario.status === "1")
      ).length;
      const total_no_iniciado_c = contratosContratistas.filter(
        (el) => !el.inventario
      ).length;

      const total_aprobados_p = contratosPropios.filter(
        (el) =>
          el.inventario &&
          (el.inventario.status === 2 || el.inventario.status === "2")
      ).length;
      const total_borrador_p = contratosPropios.filter(
        (el) =>
          el.inventario &&
          (el.inventario.status === 0 || el.inventario.status === "0")
      ).length;
      const total_revision_p = contratosPropios.filter(
        (el) =>
          el.inventario &&
          (el.inventario.status === 1 || el.inventario.status === "1")
      ).length;
      const total_no_iniciado_p = contratosPropios.filter(
        (el) => !el.inventario
      ).length;

      this.generateGraphBarPropiosContratistas(
        [
          ["Aprobados", total_aprobados_c, total_aprobados_p],
          ["Borrador", total_borrador_c, total_borrador_p],
          ["Revision", total_revision_c, total_revision_p],
          ["No iniciado", total_no_iniciado_c, total_no_iniciado_p],
        ],
        ["Aprobados", "Borrador", "Revision", "No iniciado"]
      );

      this.table_propio_contratista = {
        propios: {
          aprobados: total_aprobados_p,
          borrador: total_borrador_p,
          revision: total_revision_p,
          no_iniciado: total_no_iniciado_p,
          total:
            total_aprobados_p +
            total_borrador_p +
            total_revision_p +
            total_no_iniciado_p,
        },
        contratistas: {
          aprobados: total_aprobados_c,
          borrador: total_borrador_c,
          revision: total_revision_c,
          no_iniciado: total_no_iniciado_c,
          total:
            total_aprobados_c +
            total_borrador_c +
            total_revision_c +
            total_no_iniciado_c,
        },
      };
      this.loading = false;
    },
  },
};
</script>
<style>
.c3-axis-y > .tick {
  font-size: 15px;
}

.c3-axis-x > .tick {
  font-size: 15px;
}

.c3-chart-texts text {
  fill: black !important;
  font-weight: bold;
  font-size: 14px;
}
</style>

<style scoped>
.resize_content {
  height: 70vh !important;
}

.box-card {
  max-width: 1500px;
  margin: 0 auto;
}

span {
  font-size: 15px;
}

table {
  font-size: 13px;
}

h2 {
  font-size: 19px;
}

h3 {
  font-size: 17px;
}

.background_gray {
  background-color: gray;
}

.color_white {
  color: white;
}

.padding_cell {
  padding: 5px;
}

.salto_linea {
  display: none;
}

.none-display {
  display: none;
}

@media only screen and (max-width: 600px) {
  .full-table {
    display: none;
  }

  .min-table {
    display: inline-block;
  }
}

@media only screen and (min-width: 601px) {
  .full-table {
    display: inline-block;
  }

  .min-table {
    display: none;
  }
}
</style>
